import { ChangeWebviewHeightType } from "@swiggy-private/native-bridge";

const QC_DEFAULT_SCALE = { height: 146, type: ChangeWebviewHeightType.DP };
const QC_LOADING_SCALE = { height: 146, type: ChangeWebviewHeightType.DP };

export enum QC_FOOTER_TYPE {
    LOADING = "LOADING", // shimmer
    DEFAULT = "DEFAULT", // success
    ERROR_FOOTER = "ERROR_FOOTER", // taller functional error footer (240)
    SHORT_ERROR_FOOTER = "SHORT_ERROR_FOOTER", // location / address footer (208)
    MEDIUM_ERROR_FOOTER = "MEDIUM_ERROR_FOOTER", // items / all-unserviceable footer (225)
}

export const HEIGHT_NAVIGATION_PAYLOAD = {
    QC_DEFAULT_SCALE,
    QC_LOADING_SCALE,
    QC_TO_PAYMENTS: { height: 100, type: ChangeWebviewHeightType.PERCENT },
    PAYMENTS_TO_QC: QC_DEFAULT_SCALE,
    QC_TO_MRO_FOOD_CART: { height: 100, type: ChangeWebviewHeightType.PERCENT },
    MRO_FOOD_CART_TO_QC: QC_DEFAULT_SCALE,
    QC_CART_FOOTER_ERROR_SCALE: { height: 240, type: ChangeWebviewHeightType.DP },
    QC_CART_FOOTER_SHORT_ERROR_SCALE: { height: 208, type: ChangeWebviewHeightType.DP },
    QC_CART_FOOTER_MEDIUM_ERROR_SCALE: { height: 225, type: ChangeWebviewHeightType.DP },
};

export const QC_FOOTER_TYPE_PAYLOAD = {
    [QC_FOOTER_TYPE.LOADING]: HEIGHT_NAVIGATION_PAYLOAD.QC_LOADING_SCALE,
    [QC_FOOTER_TYPE.DEFAULT]: HEIGHT_NAVIGATION_PAYLOAD.QC_DEFAULT_SCALE,
    [QC_FOOTER_TYPE.ERROR_FOOTER]: HEIGHT_NAVIGATION_PAYLOAD.QC_CART_FOOTER_ERROR_SCALE,
    [QC_FOOTER_TYPE.SHORT_ERROR_FOOTER]: HEIGHT_NAVIGATION_PAYLOAD.QC_CART_FOOTER_SHORT_ERROR_SCALE,
    [QC_FOOTER_TYPE.MEDIUM_ERROR_FOOTER]: HEIGHT_NAVIGATION_PAYLOAD.QC_CART_FOOTER_MEDIUM_ERROR_SCALE,
} as const;
